import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../app-token.service";
import { HttpHandlerService } from "../http-handler.service";

@Injectable()
export class AddressBookService {

    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'addressbook';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(data?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}?isactive=${data?.isactive}&industrytypeid=${data?.industrytypeid}&customerid=${data?.customerid}&countryisocode=${data?.countryisocode}`

        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/list?sc=${params?.id}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public Update(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public UpdateStatus(status: boolean, productId: number): Observable<boolean> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            { status, productId }
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public Delete(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    // private handleErrorResponse(error: HttpErrorResponse) {
    //     console.log(error);
    //     if (error.status === 0) {
    //       // A client-side or network error occurred. Handle it accordingly.
    //       console.error('An error occurred:', error.error);
    //     } else {
    //       // The backend returned an unsuccessful response code.
    //       // The response body may contain clues as to what went wrong.
    //       console.error(
    //         `Backend returned code ${error.status}, body was: `, error.error);
    //     }
    //     // Return an observable with a user-facing error message.
    //     return throwError(() => new Error('Something bad happened; please try again later.'));

    //   }
}



